import { createApi } from "@reduxjs/toolkit/query/react";
import { baseQuery } from '../../../utils/baseQueryFn';


const criteriaAPI = createApi({
    reducerPath: "criteriaAPI",
    baseQuery,
    endpoints: (builder) => ({
        getAllCriteriaList: builder.mutation({
            query: ({page, size, key}) => {
                const queryParams = new URLSearchParams({
                    page,
                    size
                });
    
                if (key) {
                    queryParams.append('searchKey', key);
                }
    
                const apiUrl = `criteria/?${queryParams.toString()}`;

                return{
                    url: apiUrl,
                    method: "GET"
                }
            },
            transformResponse: (response) => response
        }),
        updateCriteria: builder.mutation({
            query: (data) => ({
                url: `criteria/${data.id}`,
                method: "PUT",
                body: {
                    label: data.label,
                    weight: data.weight,
                }
            }),
        }),
        getCriteriaListAll: builder.query({
            query: () => ({
                url: `criteria/list`,
                method: "GET",
            }),
            transformResponse: (response) => response,
        }),
        deleteCriteria: builder.mutation({
            query: (id) => ({
                url: `criteria/${id}`,
                method: "DELETE",
            }),
        }),
        createCriteria: builder.mutation({
            query: (data) => ({
                url: `criteria`,
                method: "POST",
                body: {
                    label: data.label,
                    weight: data.weight,
                }
            }),
        }),
    }),
});

export const { useGetAllCriteriaListMutation, useGetCriteriaListAllQuery, useCreateCriteriaMutation, useDeleteCriteriaMutation, useUpdateCriteriaMutation } = criteriaAPI;
export default criteriaAPI;
